/**
 * This file is auto-generated from ChatMultiSelectAnswer.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const selected: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Selected';
        case 'pl':
            return 'Zaznaczono';
    }
};

export const notSelected: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Not selected';
        case 'pl':
            return 'Nie zaznaczono';
    }
};
